import { FC } from 'react'
import Modal from '../Modal'
import siteConfig from 'config'

interface Props {
  open: boolean
  close: () => void
}

const DonateModal: FC<Props> = ({ open, close }) => {
  return (
    <Modal open={open} close={close}>
      <div className="flex flex-col gap-y-2 text-center w-full">
        <h2 className="text-2xl font-bold text-kura px-8">{siteConfig.labels.donate.prompt}</h2>
        <a href={siteConfig.contact.donateUrl} target="_blank" rel="noreferrer" className="button-primary bg-kura text-yellow-300">
          {siteConfig.labels.about.donateButton}
        </a>
        <p className="text-xs font-semibold text-kura px-8 mt-2">{siteConfig.labels.donate.footer}</p>
      </div>
    </Modal>
  )
}

export default DonateModal
